<template>
  <div id="app">
    <div class='apTitle'>{{getTitle}}</div>
    <router-view></router-view>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
export default {
  name: 'App',
  data() {
    return {
    }
  },
  computed: {
    getTitle() {
      if (this.$route.name === 'LoginPage') {
        return '测试问卷调查'
      } else if (this.$route.name === 'MainPage') {
        return '问卷调查相关信息填写'
      } else  {
        return '测试问卷信息查询'
      }
    }
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style lang='scss'>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 6px 20px 0 20px;
  .apTitle {
    font-size: 20px;
    font-weight: bolder;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue